import { render, staticRenderFns } from "./CourtPayments.vue?vue&type=template&id=fff96826&scoped=true&"
import script from "./CourtPayments.vue?vue&type=script&lang=js&"
export * from "./CourtPayments.vue?vue&type=script&lang=js&"
import style0 from "./CourtPayments.vue?vue&type=style&index=0&id=fff96826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff96826",
  null
  
)

export default component.exports